import { Role, useGetUserRoleRegistersIDs } from 'auth';
import { withPrivateAccess } from '@/modules/auth/hocs/withPrivateAccess.tsx';
import { useCurrentUserRegistersQuery } from '@/modules/investor-dashboard/queries/registers.tsx';
import IssuerRegisterIssuersItem from '@/modules/issuer-dashboard/components/items/IssuerRegisterIssuersItem.tsx';
import { EmptyListState, PageLayout, Spinner } from 'ui';

const IssuerIssuers = () => {
  const { isLoading, data } = useCurrentUserRegistersQuery();
  const registersIdsWithIssuerAdminRole = useGetUserRoleRegistersIDs(Role.SR_ISSUER_ADMIN);

  return (
    <PageLayout title="Issuers">
      {isLoading && (
        <div className="h-full w-full flex items-center justify-center">
          <Spinner size="lg" />
        </div>
      )}
      <EmptyListState
        title="No registers"
        description="You have not been added to any registry."
        isLoading={isLoading}
        isSearchUsed={false}
        itemsCount={data?.data?.length || 0}
      />
      {!isLoading && data?.data?.length && (
        <div className="flex flex-col gap-2">
          {data.data.map(register => {
            if (
              !register.register_obj ||
              !registersIdsWithIssuerAdminRole.includes(register.register_id)
            )
              return null;
            return (
              <IssuerRegisterIssuersItem
                register={register.register_obj}
                key={register.register_id}
              />
            );
          })}
        </div>
      )}
    </PageLayout>
  );
};

export default withPrivateAccess(IssuerIssuers, [Role.SR_ISSUER_ADMIN]);
